import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
    enUso: { label: i18n.t('app.in_use'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
    DetenerEjecucion: { label: i18n.t('rules.detener_ejecucion'), value: '' },
    nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
    nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'idRegla', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'Nombre', width: '440px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'Prioridad', width: '200px', title: i18n.t('configurations.prioridad'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'Activa',
      width: '200px',
      title: i18n.t('app.active'),
      columnMenu: 'myTemplate',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'DetenerEjecucion', width: '300px', title: i18n.t('rules.detener_ejecucion'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'Grupos', width: '440px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'EnUso', width: '125px', title: i18n.t('app.in_use'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
